import { BusinessUnit } from '@grupoboticario/barril-del-chavo'
import { HomeCategoryItem } from 'src/@interfaces'

export const defaultCategoriesImageByBrand: Record<BusinessUnit, string> = {
  boticario:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-generica.webp',
  eudora:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-generica.webp',
  oui: 'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-generica.webp',
  euamomake:
    'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-generica.webp',
  multibrand: '',
}
export const categoriesByBrand: Record<BusinessUnit, HomeCategoryItem[]> = {
  boticario: [
    {
      title: 'Promoções',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-promo.webp',
      url: '/categoria?category=promocao',
    },
    {
      title: 'Lançamentos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-lancamentos.webp',
      url: '/categoria?category=lancamento',
    },
    {
      title: 'Pronta entrega',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-pronta-entrega.webp',
      url: '/pronta-entrega?',
    },
    {
      title: 'Perfumaria',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-perfumaria.webp',
      url: '/categoria?category=perfumaria',
    },
    {
      title: 'Maquiagem',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-maquiagem.webp',
      url: '/categoria?category=maquiagem',
    },
    {
      title: 'Cuidados pessoais',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-cuidados-para-pele.webp',
      url: '/categoria?category=cuidados-pessoais',
    },
    {
      title: 'Cuidados para pele',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-cuidados-pessoais.webp',
      url: '/categoria?category=cuidados-para-pele',
    },
    {
      title: 'Corpo e banho',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-corpo-e-banho.webp',
      url: '/categoria?category=corpo-e-banho',
    },
    {
      title: 'Cabelos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-cabelos.webp',
      url: '/categoria?category=cabelos',
    },
    {
      title: 'Bem estar e saúde',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/bot/boti-bem-estar.webp',
      url: '/categoria?category=bem-estar-e-saude',
    },
  ],
  eudora: [
    {
      title: 'Promoções',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-promocoes.webp',
      url: '/categoria?category=promocao',
    },
    {
      title: 'Lançamentos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-lancamentos.webp',
      url: '/categoria?category=lancamento',
    },
    {
      title: 'Pronta entrega',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-pronta-entrega.webp',
      url: '/pronta-entrega?',
    },
    {
      title: 'Perfumaria',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-perfumaria.webp',
      url: '/categoria?category=perfumaria',
    },
    {
      title: 'Maquiagem',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-maquiagem.webp',
      url: '/categoria?category=maquiagem',
    },
    {
      title: 'Cuidados para pele',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-cuidados-para-pele.webp',
      url: '/categoria?category=cuidados-para-pele',
    },
    {
      title: 'Corpo e banho',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-corpo-e-banho.webp',
      url: '/categoria?category=corpo-e-banho',
    },
    {
      title: 'Cabelos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eud/eud-cabelos.webp',
      url: '/categoria?category=cabelos',
    },
  ],
  oui: [
    {
      title: 'Promoções',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-promocoes.webp',
      url: '/categoria?category=promocao',
    },
    {
      title: 'Lançamentos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-lancamentos.webp',
      url: '/categoria?category=lancamento',
    },
    {
      title: 'Pronta entrega',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-pronta-entrega.webp',
      url: '/pronta-entrega?',
    },
    {
      title: 'Perfumaria',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-perfumaria.webp',
      url: '/categoria?category=perfumaria',
    },
    {
      title: 'Cuidados para pele',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-cuidados-para-pele.webp',
      url: '/categoria?category=cuidados-para-pele',
    },
    {
      title: 'Cuidados pessoais',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-cuidados-pessoais.webp',
      url: '/categoria?category=cuidados-pessoais',
    },
    {
      title: 'Corpo e banho',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/oui/oui-corpo-e-banho.webp',
      url: '/categoria?category=corpo-e-banho',
    },
  ],
  euamomake: [
    {
      title: 'Promoções',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-promocoes.webp',
      url: '/categoria?category=promocao',
    },
    {
      title: 'Lançamentos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-lancamentos.webp',
      url: '/categoria?category=lancamento',
    },
    {
      title: 'Pronta entrega',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-pronta-entrega.webp',
      url: '/pronta-entrega?',
    },
    {
      title: 'Perfumaria',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-perfumaria.webp',
      url: '/categoria?category=perfumaria',
    },
    {
      title: 'Maquiagem',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-maquiagem.webp',
      url: '/categoria?category=maquiagem',
    },
    {
      title: 'Cuidados para pele',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-cuidados-para-pele.webp',
      url: '/categoria?category=cuidados-para-pele',
    },
    {
      title: 'Corpo e banho',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-corpo-e-banho.webp',
      url: '/categoria?category=corpo-e-banho',
    },
    {
      title: 'Cabelos',
      image:
        'https://meucatalogodigitalresources.grupoboticario.digital/assets/images/categories/eam/qdb-cabelos.webp',
      url: '/categoria?category=cabelos',
    },
  ],
  multibrand: [],
}
